import React, { useContext, useEffect, useState } from "react";
import { Text, Title } from "rizzui/typography";
import { timeOptions } from "../lib/constants";
import { Controller, useForm } from "react-hook-form";
import { Switch } from "rizzui/switch";
import { useColorStyle } from "../hooks/useColorStyle";
import { ThemeContext } from "../context/themeContext";
import {
  inputClassName,
  labelClassName,
  projectFieldValidation,
} from "../modules/projects/new/first";
import cn from "../lib/utils/class-name";
import Select from "react-select";
import { Button } from "rizzui/button";
import { useModal } from "../hooks/useModal";
import {
  convertTo12Hour,
  convertTo24Hour,
  getFullDayName,
} from "../lib/utils/convertTo24hrs";
import axios from "axios";
import { baseUrl } from "../modules/account/login";
import { AuthContext } from "../context/authContext";
import { useNavigate } from "react-router";
import { useNotifcication } from "../hooks/useNotification";
import CopyIcon from "../assets/copy";
import { Input } from "rizzui/input";
import { Radio } from "rizzui/radio";
import { useQueryClient } from "@tanstack/react-query";

export default function SetCallTime({ availability }) {
  const { theme } = useContext(ThemeContext);
  const { view, closeModal, openModal } = useModal();
  const [dayError, setDayError] = useState("");
  const [loading, setLoading] = useState(false);

  const { timeColorStyle, campaignColorStyles } = useColorStyle(theme);
  const { openNotification } = useNotifcication();

  const {
    control,
    watch,
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
    getValues,
  } = useForm();

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const campaign_id = sessionStorage.getItem("campaign_id");

  const finishCampaignAvailability = () => {
    let { timezone, callDays, callBackOption, callBackOptionTime } =
      getValues();
    setLoading(true);
    const timezone_ask = timezone;
    const callback = `${callBackOption} ${callBackOptionTime?.value}`;
    let availability = Object.keys(callDays).map((day) => {
      if (callDays[day]?.active) {
        return {
          day: getFullDayName(day),
          slots: [
            {
              start: convertTo24Hour(callDays[day]?.time?.start?.value),
              end: convertTo24Hour(callDays[day]?.time?.end?.value),
            },
          ],
        };
      } else return false;
    });
    availability = availability.filter((value) => value !== false);

    if (campaign_id) {
      return axios
        .post(
          `${baseUrl}/campaigns/${campaign_id}/availability`,
          { timezone_ask, availability, callback },
          { headers: { Authorization: AuthStr } }
        )
        .then((response) => {
          const data = response.data;
          if (response?.status === 201) {
            queryClient.refetchQueries({
              queryKey: [data?.data?._id, token],
            });
            sessionStorage.setItem("call_time", "true");
            closeModal();
            setLoading(false);
            openNotification({
              status: "success",
              message: "AI Call time set",
            });
          }
          return data;
        })
        .catch((e) => {
          setLoading(false);
          closeModal();
          if (e?.response?.data?.statusCode === 401)
            navigate("/account/logout");
          return e;
        });
    } else {
      setLoading(false);
      return sessionStorage.removeItem("new_campaign_page");
    }
  };

  const handleAvailability = handleSubmit((data) => {
    const callday = getValues("callDays");
    if (
      !callday?.Mon?.active &&
      !callday?.Tue?.active &&
      !callday?.Wed?.active &&
      !callday?.Thu?.active &&
      !callday?.Fri?.active &&
      !callday?.Sat?.active &&
      !callday?.Sun?.active
    ) {
      setDayError("Select at least one day");
    } else {
      setDayError("");
      //refetch();
      // console.log(response, callError);
      //setDone(true);
      finishCampaignAvailability();
    }
  });

  const callBackOptions = [
    { label: "minutes", value: "minutes" },
    { label: "hours", value: "hours" },
    { label: "days", value: "days" },
    { label: "weeks", value: "weeks" },
  ];

  useEffect(() => {
    reset();
    setDayError("");
  }, [view]);

  useEffect(() => {
    if (availability) {
      const { weeklyAvailability: callDays, callback_option } = availability;
      const timezone_ask = availability?.timezone_ask;
      const callBackOption = callback_option.split(" ")[0];
      const callBackOptionTime = callback_option.split(" ")[1];
      setValue("callBackOption", callBackOption);
      setValue("callBackOptionTime", {
        label: callBackOptionTime,
        value: callBackOptionTime,
      });
      setValue("timezone", timezone_ask);
      days.forEach((day) => {
        const dayData = callDays.find((d) => d.day === getFullDayName(day));
        if (dayData) {
          setValue(`callDays.${day}.active`, true);
          setValue(
            `callDays.${day}.time.start`,
            timeOptions.find(
              (option) =>
                option.value === convertTo12Hour(dayData.slots[0].start)
            )
          );
          setValue(
            `callDays.${day}.time.end`,
            timeOptions.find(
              (option) => option.value === convertTo12Hour(dayData.slots[0].end)
            )
          );
        }
      });
    }
  }, [availability, view]);

  return (
    <div className="customBar overflow-y-auto mx-auto max-h-[715px] min-h-[342px] h-auto customBar bg-background dark:bg-[#2A2C30] border-muted md:w-[471px] w-[94%] rounded-[8px] border-[0.5px]">
      <button
        className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-[18px]"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAvailability();
        }}
        noValidate
        className="flex flex-col gap-[28px] p-[32px]"
      >
        <div className="flex flex-col gap-[8px] ">
          <Title className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            {availability ? "Edit " : "Set "} AI call time
          </Title>
          <Text className="max-w-[379px] font-switzer text-[14px] font-[400] text-[#758599]">
            Select the day and time you want the AI to make the call.
          </Text>
        </div>

        <div className="flex flex-col gap-[16px]">
          <Text className={labelClassName}>
            Should we ask the lead for their timezone?*
          </Text>
          <div className="flex flex-col gap-[12px]">
            <Radio
              label="Yes, ask"
              size="sm"
              labelClassName={cn(
                labelClassName,
                "!text-primary-dark ml-[16px]"
              )}
              {...register("timezone", {
                ...projectFieldValidation,
              })}
              value="true"
            />

            <Radio
              label="No, don't ask"
              size="sm"
              labelClassName={cn(
                labelClassName,
                "!text-primary-dark ml-[16px]"
              )}
              {...register("timezone", {
                ...projectFieldValidation,
              })}
              value="false"
            />
          </div>

          {errors.timezone?.message && (
            <p className="text-red text-[13px]">{"Select an option"}</p>
          )}
        </div>

        <div className="flex flex-col gap-[8px] font-switzer text-[14px] font-[400] text-[#758599]">
          <div className="h-[350px] flex flex-col gap-[8px]">
            <Text className={labelClassName}>AI call time</Text>
            <div className="h-[326px] flex place-content-center place-items-center rounded-[4px] border border-[#758599] border-dashed">
              <div className="flex flex-col justify-around h-[95%] w-[95%]">
                {days.map((day, i) => {
                  const active = watch(`callDays.${day}.active`);
                  const startError = errors?.callDays
                    ? errors?.callDays[day]?.time?.start
                    : "";
                  const endError = errors?.callDays
                    ? errors?.callDays[day]?.time?.end
                    : "";
                  return (
                    <div className="flex md:gap-[16px] gap-[4px] h-[32px] place-items-center">
                      <Controller
                        control={control}
                        name={`callDays.${day}.active`}
                        render={({ field: { onChange, value, name } }) => (
                          <div className="w-[90px]">
                            <Switch
                              variant="flat"
                              label={day}
                              size="lg"
                              value={value}
                              checked={value}
                              name={name}
                              onChange={(value) => {
                                onChange(value);
                                if (value) {
                                  setDayError(""); // Clear dayError when a day is activated
                                }
                              }}
                              labelClassName={cn(labelClassName, "ml-[19px]")}
                            />
                          </div>
                        )}
                      />
                      {active && (
                        <>
                          <div className="w-[216px] flex justify-between">
                            <Controller
                              control={control}
                              name={`callDays.${day}.time.start`}
                              rules={{
                                required: {
                                  value: active ? true : false,
                                  message: "Required",
                                },
                              }}
                              render={({
                                field: { onChange, value, name },
                              }) => (
                                <Select
                                  options={timeOptions}
                                  placeholder="Start time"
                                  styles={timeColorStyle}
                                  isSearchable={false}
                                  isDisabled={!active}
                                  className={cn(
                                    "w-[96px] h-[32px]",
                                    startError ? "[&>div]:!border-red" : ""
                                  )}
                                  value={value}
                                  name={name}
                                  onChange={onChange}
                                />
                              )}
                            />
                            <Controller
                              control={control}
                              name={`callDays.${day}.time.end`}
                              rules={{ required: true }}
                              render={({
                                field: { onChange, value, name },
                              }) => {
                                const startTime = getValues(
                                  `callDays.${day}.time.start`
                                );
                                const startTimeIndex = timeOptions.findIndex(
                                  (option) =>
                                    option.value === (startTime?.value || "")
                                );
                                return (
                                  <Select
                                    options={timeOptions.slice(
                                      startTimeIndex + 1 || 0
                                    )}
                                    placeholder="End time"
                                    styles={timeColorStyle}
                                    isSearchable={false}
                                    isDisabled={!active}
                                    className={cn(
                                      "w-[96px] h-[32px]",
                                      endError ? "[&>div]:!border-red" : ""
                                    )}
                                    value={value}
                                    name={name}
                                    onChange={onChange}
                                  />
                                );
                              }}
                            />
                          </div>
                          {day !== "Sun" && (
                            <Button
                              className="cursor-pointer !bg-transparent !p-0 !m-0"
                              onClick={() => {
                                const nextDay = days[i + 1];
                                if (nextDay) {
                                  const currentDayData = getValues(
                                    `callDays.${day}`
                                  );
                                  if (currentDayData?.active) {
                                    setValue(
                                      `callDays.${nextDay}.active`,
                                      true
                                    ); // Set active to true for the next day
                                    setValue(
                                      `callDays.${nextDay}.time.start`,
                                      currentDayData.time?.start
                                    ); // Copy start time
                                    setValue(
                                      `callDays.${nextDay}.time.end`,
                                      currentDayData.time?.end
                                    ); // Copy end time
                                  }
                                }
                              }}
                            >
                              <CopyIcon className={"text-primary-dark"} />
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {dayError && (
            <Text className="text-[red] font-switzer text-[12px] font-[400]">
              {dayError}
            </Text>
          )}
        </div>

        <div className="flex flex-col gap-[8px]">
          <Text className={labelClassName}>Call back option</Text>
          <div className="grid grid-cols-2 gap-[16px]">
            <Input
              inputClassName={inputClassName}
              type="number"
              {...register("callBackOption", {
                required: { value: false, message: "Required" },
              })}
              error={
                errors.callBackOption?.message
                  ? "" + errors.callBackOption.message
                  : ""
              }
            />
            <Controller
              control={control}
              name="callBackOptionTime"
              rules={{
                required: {
                  value: watch("callBackOption") ? true : false,
                  message: "Required",
                },
              }}
              render={({ field: { onChange, value, name } }) => (
                <div>
                  <Select
                    options={callBackOptions}
                    className={"w-auto"}
                    placeholder=""
                    styles={campaignColorStyles}
                    isSearchable={false}
                    value={value}
                    name={name}
                    onChange={onChange}
                  />
                  {errors.callBackOptionTime?.message && (
                    <p className="text-red text-[13px] mt-0.5 rizzui-textarea-error-text">
                      {"" + errors.callBackOptionTime.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <Button
          type="submit"
          className="w-full h-[40px] !bg-btn"
          isLoading={loading}
        >
          <Text className="font-[500] font-switzer text-[12px] text-background">
            Set call time
          </Text>
        </Button>
      </form>
    </div>
  );
}
